import { render, staticRenderFns } from "./defaultTable.vue?vue&type=template&id=3493b44c&scoped=true&"
import script from "./defaultTable.vue?vue&type=script&lang=js&"
export * from "./defaultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3493b44c",
  null
  
)

export default component.exports